import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function EventCard({ event, index = 0, to = "/tickets" }) {
  const d = new Date(event.date + "T00:00:00");
  const day = d.getDate();
  const month = d.toLocaleString("en-US", { month: "short" }).toUpperCase();
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (index % 3) * 0.08 }}
      className="group relative"
      data-testid={`event-card-${event.id}`}
    >
      <Link to={`${to}?event=${event.id}`} className="block">
        <div className="relative overflow-hidden aspect-[4/5] bg-brand-ink">
          <img
            src={event.cover_image_url}
            alt={event.title}
            className="absolute inset-0 w-full h-full object-cover opacity-90 grayscale-[15%] group-hover:scale-105 group-hover:grayscale-0 transition-[transform,filter] duration-700 ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/80 via-transparent to-transparent" />
          <div className="absolute top-4 left-4 bg-brand-orange text-white text-center px-3 py-2 leading-none">
            <div className="font-head font-extrabold text-2xl">{day}</div>
            <div className="font-mono text-[10px] tracking-widest">{month}</div>
          </div>
          <div className="absolute top-4 right-4">
            <span className="font-mono text-[10px] uppercase tracking-widest bg-white/90 text-brand-ink px-3 py-1.5">
              {event.is_free ? "Free · RSVP" : `$${event.price}`}
            </span>
          </div>
          <div className="absolute bottom-0 inset-x-0 p-5 text-white">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand-orange mb-1">
              {event.city}
            </div>
            <h3 className="font-head font-extrabold text-3xl leading-none uppercase">{event.title}</h3>
            <div className="flex items-center justify-between mt-3">
              <span className="text-white/70 text-sm">{event.venue}</span>
              <span className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity">
                {event.is_free ? "RSVP" : "Buy"} <ArrowUpRight size={14} />
              </span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
